import { server } from '../core/server/axios';

export class PrinterAgentController {
	async getPrinters(): Promise<any> {
		return await server.get('/printers', {
			baseURL: "http://localhost:5001"
		});
	}

	async autoPrint({ fileBase64 }: { fileBase64: string, }): Promise<any> {
		return await server.post('/print', { fileBase64, printer: "Mulex P80mm" }, {
			baseURL: "http://localhost:5001"
		});
	}
}